// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrentSessionBox_container__3Vgzv","userType":"CurrentSessionBox_userType__1eZ_9","smallMarginTop":"CurrentSessionBox_smallMarginTop__g1YBQ"};